module.exports = __webpack_public_path__ + "img/mulish-v11-latin-700italic.44702e2.svg";